module.exports = __webpack_public_path__ + "img/condormirador.2d9d65c5.jpg";